import React from 'react';
import PropTypes from 'prop-types';
import {CardForm} from './';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import * as Actions from 'actions';

class AddCard extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'AddCard';
        this.createNewCard = this.createNewCard.bind(this);
        this.cancel = this.cancel.bind(this);
       	this.state = {
       		card : null,
       	}
    }
    createNewCard(card) {

    	this.props.createCard(card, (error) => {
            if(error) {
                //TODO: Show error
                if(typeof this.props.onError === 'function')
                    this.props.onError(error);

                this.props.notify(error, {type : "error", style : "danger", position: "stack-bar-top"});
            }
            else {
                this.props.hideAddCard();
                if(typeof this.props.onSuccess === 'function')
                    this.props.onSuccess({message : "Card added successfully."})
                this.props.notify({message : "Card added successfully."}, {type : "success", style : "success", position: "stack-bar-top"});
                this.props.getCustomer();
            }
        });
    }
    cancel() {
    	this.props.updateCard(null);
      this.props.hideAddCard();
    }
    render() {
      return (
        <div>
          {(()=>{
            if(this.props.account.addingCard)
              return (
              	<Modal show={this.props.account.addingCard} onHide={this.cancel} >
                  <div className="panel panel-primary mb-none">
                    <div className="panel-heading">
                      <h3 className="panel-title">Add Card</h3>
                    </div>
                    <div className="panel-body">
                      <CardForm onSave={this.createNewCard} onCancel={this.cancel} />
                    </div>
                  </div>
              	</Modal>
            	);
         	 })()}
        </div>
      );
    }
}

var mapStateToProps = ({account, connection}) => {
    return {
        account,
        connection
    }
}

export default connect(mapStateToProps, Actions)(AddCard);



// WEBPACK FOOTER //
// ./src/browser/components/account/addCard.js